import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import s from './hb-jewel.scss';

class HbJewel extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    text: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }

  render() {
    const {
      className,
      textClassName,
      text,
    } = this.props;
    const rootClassName = cx(s.root, className, 'hb-Jewel');

    return (
      <span className={rootClassName}>
        <span className={cx(s.text, textClassName, 'hb-jewel__text')}>
          {text}
        </span>
      </span>
    );
  }
}

export default HbJewel;
